import barba from '@barba/core';
import gsap from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


export default class{

	constructor(){
        barba.hooks.afterOnce((data) => {
            this.pictureScroll()
        });
        barba.hooks.after((data) => {
            this.pictureScroll()
        });

    }
    pictureScroll(){
        // this.trigger = document.querySelector('.js-scrollTrigger__bg');
        // this.elem = document.querySelectorAll('.js-scrollElem__bg');
        // if(this.elem) {
        //     this.elem.forEach((el, i) => {
        //         gsap.to(el, {
        //             x: '-10vw',
        //             scrollTrigger: {
        //               trigger: this.trigger,
        //               start: 'top bottom' ,
        //               end: '+150% center',  
        //               scrub: 1, 
        //             }
        //         });
        //     })
        // }
        const tl = gsap.timeline({
            scrollTrigger:{
                trigger:'.js-scrollElem__bg',
                // markers: true,
                start: 'top center' ,
                end: 'bottom bottom',  
                pin:false,
                scrub:3,
                toggleActions:'play none none reverse'
            }
        });
        
        tl.fromTo("path",
            {'stroke-dashoffset':'3000px','stroke-dasharray': '3000px'},
            {'stroke-dashoffset':'0','stroke-dasharray': '3000px' ,duration:4,stagger:.05}
        )
    }
}